<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.entrance, 'Scara')"
      v-model="entrance"
      :rules="entranceValidationRules"
      name="entrance"
      variant="outlined"
      bg-color="surface"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    addressIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, addressIndex } = toRefs(props);
    const entrance = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      entrance.value = newValue;
    });

    watch(entrance, (newValue) => {
      const isValid = validateEntrance(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `entrance-${addressIndex.value}` : 'entrance', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const entranceValidationRules = [
      (v: string) => /^[A-Za-z0-9\s]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateEntrance(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = entranceValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return entranceValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateEntrance(entrance.value);
      emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `entrance-${addressIndex.value}` : 'entrance', isValid });

      // Listen for validate events
      window.addEventListener('validate-address', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === (Number.isInteger(addressIndex.value) ? `entrance-${addressIndex.value}` : 'entrance')) {
        const isValid = validateEntrance(entrance.value, true);
        if (isValid) {
          emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `entrance-${addressIndex.value}` : 'entrance', isValid });
        }
      }
    };

    return {
      entrance,
      entranceValidationRules,
      translationList,
      translation,
      error
    };
  },
});
</script>

<style scoped>
</style>